import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import useProjectRoute from 'hooks/useProjectRoute';

const FlowIdContext = createContext<string | undefined>(undefined);

export const FlowIdContextProvider = ({
  children,
  flowId,
}: {
  children: ReactNode;
  flowId?: string;
}) => {
  return (
    <FlowIdContext.Provider value={flowId}>{children}</FlowIdContext.Provider>
  );
};

export const useFlowId = () => {
  const contextId = useContext(FlowIdContext);
  const { flowId } = useProjectRoute<{ flowId: string }>();

  return contextId ?? flowId;
};
